// Site-wide experience toggles — owner-controlled from Admin → Settings, fetched via /api/site-status
export const DEFAULT_EXPERIENCE = {
  ambientSound: true,
  ambientVolume: 0.12,
  voiceNarration: true,
  voiceCommands: true,
  introEntrance: true,
  journeyPrompt: true,
  chatWidget: true,
  reviewPrompt: true,
  occasionReminders: true,
  goldCursor: true,
};

let exp = { ...DEFAULT_EXPERIENCE };

export const setExperience = (e) => {
  exp = { ...DEFAULT_EXPERIENCE, ...(e || {}) };
};

export const expOn = (k) => exp[k] !== false;

export const ambientLevel = (kind) => {
  const v = Math.max(0, Math.min(0.3, Number(exp.ambientVolume) || DEFAULT_EXPERIENCE.ambientVolume));
  return kind === "world" ? Math.round(v * 0.6 * 1000) / 1000 : v;
};
